import React from 'react';
import { motion } from 'framer-motion';
export function HeroVisual({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative w-full h-full ${className}`} data-id="element-179">
      <svg viewBox="0 0 400 400" className="w-full h-full opacity-40" data-id="element-180">
        <defs data-id="element-181">
          <radialGradient id="glow" cx="50%" cy="50%" r="50%" data-id="element-182">
            <stop offset="0%" stopColor="#00e5ff" stopOpacity="0.4" data-id="element-183" />
            <stop offset="100%" stopColor="#00e5ff" stopOpacity="0" data-id="element-184" />
          </radialGradient>
        </defs>

        {/* Center Glow */}
        <circle cx="200" cy="200" r="100" fill="url(#glow)" data-id="element-185" />

        {/* Outer Ring */}
        <motion.circle cx="200" cy="200" r="180" fill="none" stroke="#00e5ff" strokeWidth="1" strokeOpacity="0.2" strokeDasharray="10 20 50 10" animate={{
        rotate: 360
      }} transition={{
        duration: 40,
        repeat: Infinity,
        ease: 'linear'
      }} style={{
        originX: '50%',
        originY: '50%'
      }} data-id="element-186" />

        {/* Middle Ring */}
        <motion.circle cx="200" cy="200" r="140" fill="none" stroke="#0066ff" strokeWidth="2" strokeOpacity="0.4" strokeDasharray="100 40 20 40" animate={{
        rotate: -360
      }} transition={{
        duration: 25,
        repeat: Infinity,
        ease: 'linear'
      }} style={{
        originX: '50%',
        originY: '50%'
      }} data-id="element-187" />

        {/* Inner Ring */}
        <motion.circle cx="200" cy="200" r="100" fill="none" stroke="#00e5ff" strokeWidth="1.5" strokeOpacity="0.6" strokeDasharray="40 10" animate={{
        rotate: 360
      }} transition={{
        duration: 15,
        repeat: Infinity,
        ease: 'linear'
      }} style={{
        originX: '50%',
        originY: '50%'
      }} data-id="element-188" />

        {/* Orbiting Nodes */}
        <motion.g animate={{
        rotate: 360
      }} transition={{
        duration: 25,
        repeat: Infinity,
        ease: 'linear'
      }} style={{
        originX: '50%',
        originY: '50%'
      }} data-id="element-189">
          <circle cx="200" cy="60" r="4" fill="#00e5ff" className="shadow-[0_0_10px_#00e5ff]" data-id="element-190" />
          <circle cx="200" cy="340" r="3" fill="#0066ff" data-id="element-191" />
        </motion.g>
      </svg>
    </div>;
}